import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Globe, Heart } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_site-builder-3580/artifacts/8f1fzcms_image.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#15082a] border-t border-[rgba(212,175,55,0.2)]"
    >
      <div className="absolute inset-x-0 top-0 gold-divider" />
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <div className="h-16 w-16 rounded-full bg-[#f7f2e7] flex items-center justify-center ring-1 ring-[rgba(212,175,55,0.45)] shrink-0 overflow-hidden">
              <img src={LOGO_URL} alt="Beds of Haven" className="h-[88%] w-[88%] object-contain" />
            </div>
            <div>
              <div className="font-serif text-2xl gold-text">Beds of Haven</div>
              <p className="text-[#b395d6] text-xs tracking-[0.25em] uppercase mt-1">
                A Safe Place · A Fresh Start · A Better Future
              </p>
            </div>
          </div>
          <p className="text-[#dcd0b3] mt-5 max-w-md leading-relaxed">
            An Independent Shared Housing Program providing comfortable,
            supportive homes for adults 30+ who are ready to build a stronger,
            more stable tomorrow.
          </p>
        </div>

        <div>
          <div className="text-[#f0d479] font-medium mb-3 tracking-wide">Explore</div>
          <ul className="space-y-2 text-[#dcd0b3]">
            <li><Link to="/" className="hover:text-[#f0d479]">Home</Link></li>
            <li><Link to="/womens" className="hover:text-[#f0d479]">Women's Haven</Link></li>
            <li><Link to="/mens" className="hover:text-[#f0d479]">Men's Haven</Link></li>
            <li><Link to="/about" className="hover:text-[#f0d479]">About</Link></li>
            <li><Link to="/apply" className="hover:text-[#f0d479]">Apply</Link></li>
            <li><Link to="/contact" className="hover:text-[#f0d479]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[#f0d479] font-medium mb-3 tracking-wide">Get in Touch</div>
          <ul className="space-y-3 text-[#dcd0b3]">
            <li className="flex items-center gap-2">
              <Phone size={15} className="text-[#d4af37]" />
              <a href="tel:7064318996" data-testid="footer-phone" className="hover:text-[#f0d479]">706-431-8996</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={15} className="text-[#d4af37]" />
              <a href="mailto:bedsofhaven@yahoo.com" data-testid="footer-email" className="hover:text-[#f0d479] break-all">bedsofhaven@yahoo.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Globe size={15} className="text-[#d4af37]" />
              <span>www.bedsofhaven.com</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[rgba(212,175,55,0.15)]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#9b87b5]">
          <div>© {new Date().getFullYear()} Beds of Haven. All rights reserved.</div>
          <div className="flex items-center gap-2">
            Healing Lives. Building Futures. Creating Haven.
            <Heart size={12} className="text-[#d4af37]" />
          </div>
        </div>
      </div>
    </footer>
  );
}
